<template>
  <div class="notification-filter bg-white p-3 border-bottom shadow-sm">
    <div class="d-flex flex-wrap align-items-center justify-content-between">
      <!-- Status Filter -->
      <div class="filter-group mb-2 mb-md-0">
        <div class="btn-group btn-group-sm mr-3">
          <button 
            v-for="status in statuses" 
            :key="status.value"
            class="btn"
            :class="value.status === status.value ? 'btn-primary' : 'btn-outline-secondary'"
            @click="updateFilter('status', status.value)"
          >
            {{ status.label }}
          </button>
        </div>
      </div>

      <!-- Type Filter -->
      <div class="filter-group d-flex align-items-center">
        <select 
          class="form-control form-control-sm mr-2" 
          style="width: 140px;"
          :value="value.type"
          @change="updateFilter('type', $event.target.value)"
        >
          <option value="all">Tất cả loại</option>
          <option value="order">Hàng hóa/Đơn</option>
          <option value="inventory">Kho hàng</option>
          <option value="finance">Tài chính</option>
          <option value="customer">Khách hàng</option>
          <option value="user">Nhân viên</option>
          <option value="system">Hệ thống</option>
        </select>

        <select 
          class="form-control form-control-sm" 
          style="width: 140px;"
          :value="value.level"
          @change="updateFilter('level', $event.target.value)"
        >
          <option value="all">Tất cả mức độ</option>
          <option value="info">Thông tin</option>
          <option value="warning">Cảnh báo</option>
          <option value="danger">Nguy hiểm</option>
        </select>
        
        <button class="btn btn-sm btn-link text-primary ml-2" @click="resetFilters">
          <i class="fas fa-undo"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationFilter',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      statuses: [
        { label: 'Tất cả', value: 'all' },
        { label: 'Chưa đọc', value: 'unread' }
      ]
    }
  },
  methods: {
    updateFilter(key, val) {
      this.$emit('input', { ...this.value, [key]: val });
    },
    resetFilters() {
      this.$emit('input', { status: 'all', type: 'all', level: 'all' });
    }
  }
}
</script>

